import React from "react";
import { Outlet, useNavigate, useParams, NavLink } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase-config";

const linkStyle = ({ isActive }) => ({
  textDecoration: "none",
  fontWeight: 600,
  opacity: isActive ? 1 : 0.7,
});

export default function CheckinConsoleLayout() {
  const navigate = useNavigate();
  const { orgId, eventId } = useParams();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/checkin-console/login", { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F8FAFC",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          bgcolor: "white",
        }}
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Check-in Console
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Org: {orgId} • Event: {eventId}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <NavLink to={`/checkin-console/${orgId}/${eventId}/scan`} style={linkStyle}>
            Scan
          </NavLink>
          <NavLink to={`/checkin-console/${orgId}/${eventId}/status`} style={linkStyle}>
            Status
          </NavLink>

          <Button variant="outlined" size="small" onClick={handleLogout}>
            Logout
          </Button>
        </Box>
      </Box>

      <Box sx={{ flex: 1, p: 2 }}>
        <Outlet />
      </Box>
    </Box>
  );
}